<template>
  <v-dialog v-model="dialog" persistent max-width="550">
    <v-card v-if="Invoice" grid-list-md :loading="loading">
      <!-- <v-toolbar dense class="mb-3" :dark="false" flat color="grey lighten-3">
        <v-toolbar-title class="subtitle-1">
          {{ `Invoice # ${Invoice.localId}` }}
        </v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-btn small icon @click.stop.prevent="$emit('close')">
          <v-icon small>close</v-icon>
        </v-btn>
      </v-toolbar> -->
      <ModelTitle :title="`Invoice # ${Invoice.localId}`" @close="close()" />
      <v-card-text>

        <v-row>
          <v-col cols="12" sm="12">
            <v-layout row wrap>
              <v-flex shrink>
                <div class="my-2 font-weight-bold">
                  Invoice Amount:
                </div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <div class="my-2 font-weight-bold">{{ Invoice.total | currency }}</div>
              </v-flex>
            </v-layout>
          </v-col>
        </v-row>
        <v-card outlined class="mt-4">
          <v-card-text>
            <v-list class="list-350">
              <template v-for="(row, index) in Transactions">
                <v-list-item three-line @click="transactionDetailDialogOpen(row)" :key="index">
                  <v-list-item-icon v-if="row.status === 'settled'">
                    <v-icon color="green">mdi-check-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-icon v-if="row.status === 'voided' || row.status === 'returned'">
                    <v-icon color="red">mdi-close-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <div class="text-left">{{ row.createdAt | moment("MM/DD/YYYY") }}</div>
                    <div class="text-left">{{ row.metadata.last_4 }}</div>
                    <v-list-item-subtitle>{{ row.metadata.error_message }}</v-list-item-subtitle>
                    <!-- <v-list-item-subtitle>{{ row.metadata.error_message }}</v-list-item-subtitle> -->
                  </v-list-item-content>
                  <v-list-item-content>
                    <div class="text-right">{{ row.amount | currency }}</div>
                    <div class="text-right"><span class="text-capitalize">{{ row.status }}</span> - {{
                      row.transactionId }}</div>
                  </v-list-item-content>
                  
                </v-list-item>
                <v-divider v-if="Transactions.length > 1" :key="`${index}_divider`"></v-divider>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
    <TransactionDetailDialog :openTransactionDetail="openTransactionDetail" @close="openTransactionDetail = false"
      :selectedTransaction="selectedTransaction" />
  </v-dialog>
</template>

<script>
import TransactionDetailDialog from "@/modules/Invoice/components/TransactionDetail.vue";
import invoiceService from "@/modules/Invoice/service.js";

export default {
  name: "open-transaction",
  props: {
    openTransactionDialog: {
      default: false,
    },
    selectedInvoice: {
      type: Object,
    },
  },
  data() {
    return {
      loading: true,
      dialog: false,
      Invoice: null,
      openTransactionDetail: false,
      selectedTransaction: null,
      Transactions: null,
    };
  },
  watch: {
    openTransactionDialog(val) {
      this.Invoice = this.selectedInvoice;
      this.getTransaction()
      this.dialog = val;
    },
  },
  components: {
    TransactionDetailDialog
  },
  methods: {
    getTransaction() {
      return invoiceService.getAllTransactionByInvoice(this.Invoice.id).then((response) => {
        console.log("getAllTransactionByInvoice", response);
        this.loading = false;
        this.Transactions = response.data;
        return response;
      }).catch((error) => {
        this.loading = false;
        console.log('getList', error)
      })
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Invoice = null;
      this.selectedTransaction = null
      this.Transactions = null
    },
    transactionDetailDialogOpen(val) {
      this.selectedTransaction = val
      this.openTransactionDetail = true
    },
  },
};
</script>

<style scoped></style>
